import { CaretDown } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

/**
 * `.pen` → `ds/disclosure/accordion`. Secção colapsada (fechada por defeito)
 * para itens arquivados.
 *
 * `countText` é opcional: quando fornecido (já pluralizado, ex.: "2 ativos"),
 * o cabeçalho passa a duas linhas — título a negrito seguido do texto — tal
 * como o `.pen` mostra para "Arquivados". Sem `countText`, mantém o formato
 * de linha única "{title} ({count})" já usado por outras páginas.
 */
export function ArchivedCollapsibleSection({
  title,
  hint,
  count,
  countText,
  children,
  className,
}) {
  if (!count) return null;

  return (
    <details
      className={cn(
        'group rounded-ds-lg border border-sage-border bg-card',
        className,
      )}
    >
      <summary className="flex cursor-pointer list-none items-center justify-between gap-space-3 px-space-4 py-space-3 marker:content-none [&::-webkit-details-marker]:hidden">
        {countText ? (
          <span className="flex min-w-0 flex-col gap-space-1">
            <span className="type-body-sm font-semibold text-foreground">{title}</span>
            <span className="type-body-sm text-muted-foreground">{countText}</span>
          </span>
        ) : (
          <span className="flex min-w-0 flex-col gap-0.5 text-sm font-medium text-muted-foreground sm:flex-row sm:items-center sm:gap-2">
            <span>
              {title}
              <span className="ml-1.5 font-normal text-muted-foreground">({count})</span>
            </span>
            {hint ? (
              <span className="text-xs font-normal text-muted-foreground">{hint}</span>
            ) : null}
          </span>
        )}
        <CaretDown
          className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-180"
          aria-hidden
        />
      </summary>
      <div className="flex flex-col gap-space-2 border-t border-border px-space-4 pb-space-4 pt-space-3">
        {children}
      </div>
    </details>
  );
}
